<template>

    <div class="container-fluid">

        <div class="login-page">

            <div class="login-container">

                <div class="w-100">
                    <a href="/"><img src="/images/card/logo.svg" class="logo"></a>
                </div>

                <div class="w-100">
                    <h1>Logga in</h1>
                    <p class="mb-5">Logga in med ditt Hälsoresurs-konto. Om du saknar ett konto, så kontakta din arbetsplats.</p>

                    <form @submit.prevent="posterPost">

                        <div class="login-form" :class="{loading: poster.submitted}">
                            <input-text
                                type="tel"
                                name="phone"
                                label="Mobilnummer"
                                :form-group-class="['mb-0', {'is-invalid': poster.unhandled_error}]"
                                v-model="phone"
                                :float-label="true"
                                custom-error-message=" "
                            />
                            <div class="separator"><div class="separator-line"></div></div>
                            <input-text
                                type="password"
                                name="password"
                                label="Lösenord"
                                form-group-class="mb-0"
                                v-model="password"
                                :float-label="true"
                            />
                            <div class="invalid-feedback">
                                Mobilnumret och lösenordet stämmer inte överens. Vänligen försök igen.
                            </div>
                            <div class="loader"><div class="spinner"></div></div>
                        </div>

                        <div class="d-grid mt-3">
                            <button type="submit" class="btn btn-primary" :disabled="poster.submitted">
                                Logga in
                            </button>
                        </div>

                    </form>

                </div>

                <div class="forgot-link-container">
                    <router-link to="/password/forgot">Jag har glömt mitt lösenord</router-link>
                </div>

            </div>

        </div>

    </div>

</template>

<script>

import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    data () {
        return {
            phone: '',
            password: ''
        }
    },

    computed: {
        posterUrl () {
            return '/login'
        },
        posterData () {
            return {
                phone: this.phone,
                password: this.password
            }
        }
    },

    methods: {
        posterSuccess () {
            window.location.href = '/'
        }
    }

}
</script>
